"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
var react_1 = __importDefault(require("react"));
var Cores_1 = require("../Cores/Cores");
var ArquivosEDados_1 = __importDefault(require("../Icone/Categorias/ArquivosEDados"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Titulo_1 = require("../Tipografia/Titulo/Titulo");
var obterCores = function (tipo) {
    switch (tipo) {
        case "branco":
            return [
                Cores_1.Cores.GradacaoNeutros.CinzaFillMU100,
                Cores_1.Cores.TextoPadrao.CinzaMU600,
                Cores_1.Cores.TextoPadrao.CinzaMU600,
            ];
        case "azulClaro":
            return [
                Cores_1.Cores.GradacaoPrimaria.AzulMU500,
                Cores_1.Cores.TextoDestaque.BrancoMU50,
                Cores_1.Cores.TextoDestaque.AzulEscuroMU900,
            ];
        case "azul":
            return [
                Cores_1.Cores.GradacaoPrimaria.AzulFill700,
                Cores_1.Cores.TextoDestaque.BrancoMU50,
                Cores_1.Cores.TextoDestaque.BrancoMU50,
            ];
        case "azulEscuro":
            return [
                Cores_1.Cores.GradacaoPrimaria.AzulFillMU800,
                Cores_1.Cores.TextoDestaque.BrancoMU50,
                Cores_1.Cores.TextoDestaque.BrancoMU50,
            ];
        default:
            return [""];
    }
};
var tituloTile = function (titulo, cores) { return (react_1.default.createElement(Corpo_1.Corpo, { negrito: 700, cor: cores[1], tipo: "button1" }, titulo)); };
var subtituloTile = function (tipo, subtitulo, cores) { return (react_1.default.createElement(Corpo_1.Corpo, { cor: tipo === "azulClaro"
        ? cores[1]
        : cores[2], tipo: "caption" }, subtitulo)); };
var descricaoTile = function (descricao, cores) { return (react_1.default.createElement(Titulo_1.Titulo, { negrito: true, cor: cores[2], tipo: "cabecalho3" }, descricao)); };
var Tile = function (_a) {
    var titulo = _a.titulo, subtitulo = _a.subtitulo, descricao = _a.descricao, tamanho = _a.tamanho, tipo = _a.tipo, imagem = _a.imagem, largura = _a.largura, altura = _a.altura;
    var cores = obterCores(tipo);
    var ImagemDefault = ArquivosEDados_1.default.image;
    var imagemValor = imagem !== null && imagem !== void 0 ? imagem : ImagemDefault;
    var tamanhoIcone = tamanho === "padrao" ? 96 : 38.4;
    return (react_1.default.createElement("div", { style: {
            backgroundColor: cores[0],
            padding: tamanho === "padrao" ? "16px 32px" : "29px 24px",
            width: largura !== null && largura !== void 0 ? largura : (tamanho === "padrao" ? "160px" : "320px"),
            height: altura !== null && altura !== void 0 ? altura : (tamanho === "padrao" ? "184px" : "124px"),
            borderRadius: "8px",
            display: "flex",
            flexDirection: tamanho === "padrao" ? "column" : "row",
            alignItems: "center",
            textAlign: "center",
            boxShadow: "0px 0px 6px 0px rgba(24, 24, 24, 0.20)",
            transition: "all 0.2s ease-in-out",
        } },
        react_1.default.createElement("div", { className: "containerImagem", style: {
                padding: "0px",
                minWidth: tamanho === "padrao" ? "96px" : "64px",
                minHeight: tamanho === "padrao" ? "96px" : "64px",
                borderRadius: tamanho === "expandido" ? "50%" : "0px",
                boxShadow: tamanho === "expandido"
                    ? "0px 0px 6px 0px rgba(24, 24, 24, 0.20)"
                    : "none",
                backgroundColor: tamanho === "expandido" ? "#fff" : "transparent",
                marginBottom: tamanho === "padrao" ? "16px" : "0px",
                alignContent: "center",
            } }, typeof imagemValor === "string" ? (react_1.default.createElement("img", { src: imagemValor, alt: titulo, width: tamanhoIcone, height: tamanhoIcone, style: {
                display: "block",
                width: tamanhoIcone,
                height: tamanhoIcone,
                color: tipo === "branco" && tamanho === "padrao"
                    ? cores[1]
                    : cores[0],
                justifySelf: "center",
            } })) : react_1.default.isValidElement(imagemValor) ? ((function () {
            var _a, _b, _c;
            var elem = imagemValor;
            var existingProps = (elem && elem.props) || {};
            return react_1.default.cloneElement(elem, {
                width: (_a = existingProps.width) !== null && _a !== void 0 ? _a : tamanhoIcone,
                height: (_b = existingProps.height) !== null && _b !== void 0 ? _b : tamanhoIcone,
                "aria-label": (_c = existingProps["aria-label"]) !== null && _c !== void 0 ? _c : titulo,
                style: __assign({ display: "block", color: tipo === "branco" || tamanho === "padrao"
                        ? cores[1]
                        : cores[0], justifySelf: "center" }, existingProps.style),
            });
        })()) : ((function () {
            var IconComp = imagemValor;
            return (react_1.default.createElement(IconComp, { width: tamanhoIcone, height: tamanhoIcone, "aria-label": titulo, style: {
                    display: "block",
                    color: tipo === "branco" ||
                        tamanho === "padrao"
                        ? cores[1]
                        : cores[0],
                    justifySelf: "center",
                } }));
        })())),
        react_1.default.createElement("div", { className: "containerTile", style: {
                marginLeft: tamanho === "padrao" ? "0px" : "24px",
                width: "100%",
                justifyItems: tamanho === "padrao" ? "center" : "flex-start ",
            } },
            tituloTile(titulo, cores),
            subtitulo && subtituloTile(tipo, subtitulo, cores),
            descricao && descricaoTile(descricao, cores))));
};
exports.Tile = Tile;
